<template>
	<div class="multiple_group_block">
		<div class="multiple_group_block__wrap"
		     :class="{error : error}"
		     v-for="(value, key) in values"
		     :key="key">
			<form-field-email
					v-if="type == 'e-mail'"
					ref="fields"
					:value="value"
					:field-props="fieldProps"
					v-model="values[key]"
					:disable="disable(values, key)"
					@is-error="isError">
			</form-field-email>
			<form-field-phone
					v-else-if="type == 'phone'"
					ref="fields"
					:value="value"
					:fieldProps="fieldProps"
					v-model="values[key]"
					:disable="disable(values, key)"
					@is-error="isError">
			</form-field-phone>
			<form-field-text
					v-else
					ref="fields"
					:value="value"
					:fieldProps="fieldProps"
					v-model="values[key]"
					:disable="disable(values, key)"
					@is-error="isError">
			</form-field-text>
		</div>
		<button class="add_fields"
		        :class="{left: values.length > 1}"
		        v-show="values[values.length - 1] && !error"
		        @click="addField"
		        v-html="'+'"></button>
		<button class="del_fields"
		        v-show="values.length > 1"
		        @click="delField"
		        v-html="'-'"></button>
	</div>
</template>

<script>
	export default {
		name: "FormFieldMultiple",
		props: {
			fieldProps: {
				type: [Object, Array],
				default: function () {
					return {}
				}
			},
			value: {
				type: [Array, String],
				default: function () {
					return []
				}
			},
			type: {
				type: [String],
				default: 'text'
			},
		},
		data: function () {
			return {
				error: false,
				errorBlockHeight: 0,
				values: this.value,
			}
		},
		computed: {},
		watch: {
			error() {
				this.$nextTick(() => {
					let group = document.getElementsByClassName('multiple_group_block');

					for (let field of group) {
						let errorBlock = field.getElementsByClassName('error_block'),
							button = field.getElementsByClassName('del_fields');
						if (this.error) {
							this.errorBlockHeight = errorBlock[errorBlock.length - 1].offsetHeight;
						} else {
							this.errorBlockHeight = 0;
						}
						button[0].style.bottom = 10 + this.errorBlockHeight + 'px';
					}
				});
			}
		},
		methods: {
			async checkValid() {
				let isValid = true;

				for (let field of this.$refs.fields) {
					let val = await field.checkValid();
					if (!val) {
						isValid = false;
					}
				}

				if (isValid) {
					return true;
				} else {
					return false
				}
			},
			isError(data) {
				this.error = data.error;
			},
			addField() {
				this.fieldProps.VALUE.push('');
			},
			delField() {
				this.fieldProps.VALUE.pop();
				this.error = false;
			},
			disable(value, key) {
				if (key !== (value.length - 1)) return true;
			},
		},
	}
</script>